/**
 * @module Experience/Services
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Injectable } from '@angular/core';
import { AES, lib } from 'crypto-js';
import * as CryptoJS from 'crypto-js';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
import { LoggerService } from '@core/logger/services/logger.service';
import { GLOBAL_CONSTANT } from '@support/shared/constants/app.constants';
import { AppConfig } from '@root/app.config';

@Injectable(
  { providedIn: 'root' }
)
export class CryptoEncrytionService {
  constructor(
    private stateStoreUtilService: StateStoreUtilsService,
    private logger: LoggerService,
    private appConfig: AppConfig
  ) {}
  /**
   * Method to encrypt value with AES encrption
   * @param value which need to encrypt
   * @returns string
   */
  public encryptWithAES(value: string): string {
    try {
      const bitLength = 16;
      const iv = lib.WordArray.random(bitLength);
      const tempInteractionString = this.stateStoreUtilService.getTempInteractionString();
      const encryptedValue = AES.encrypt(value, tempInteractionString, { iv: iv });
      return encryptedValue.toString();
    } catch (error) {
      this.logger.error(
        'SharedModule',
        'CryptoEncrptionService',
        'Error in AES encryption',
        'NA',
        error
      );
    }
  }

  public encryptVestaTokenWithAES(value: string): string {
    try {
      const timestamp = new Date().toISOString();
      const action = GLOBAL_CONSTANT.UNAUTH_REFILL;
      const decrypted = `Timestamp="${timestamp}",Action="${action}",MSISDN="${value}"`;
      const iv = CryptoJS.enc.Utf8.parse(this.appConfig.getConfig('v_AES_k'));
      const encryptedValue = AES.encrypt(
        decrypted,
        CryptoJS.enc.Utf8.parse(this.appConfig.getConfig('v_AES_s')),
        { iv: iv }
      );
      return encodeURIComponent(encryptedValue);
    } catch (error) {
      this.logger.error(
        'SharedModule',
        'CryptoEncrptionService',
        'Error in AES encryption',
        'NA',
        error
      );
    }
  }
}
